import {
  createApartment,
  getApartments,
  getApartmentsByObject,
  getSingleApartment,
  updateApartment,
  getCheckerBoardLayout,
  getFlatsPlannings,
  getRoomsCountByApartment,
  getBadges,
  bookFlat,
  unbronFlat,
} from "@/api/apartment";

export default {
  FETCH_APARTMENTS({ commit }, data) {
    return new Promise((resolve, reject) => {
      getApartments(data)
        .then((response) => {
          commit("SET_APARTMENTS", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  FETCH_APARTMENTS_BY_OBJECT({ commit }, data) {
    return new Promise((resolve, reject) => {
      getApartmentsByObject(data)
        .then((response) => {
          commit("SET_APARTMENTS", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  ADD_APARTMENT(a, data) {
    return createApartment(data);
  },
  EDIT_APARTMENT(a, data) {
    return updateApartment(data);
  },
  FETCH_ONE_APARTMENT({ commit }, data) {
    return new Promise((resolve, reject) => {
      getSingleApartment(data)
        .then((response) => {
          commit("SET_ONE_APARTMENT", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  FETCH_APARTMENT_CHECKERBOARD_LAYOUT({ commit }, data) {
    return new Promise((resolve, reject) => {
      getCheckerBoardLayout(data)
        .then((response) => {
          commit("SET_APARTMENT_CHECKERBOARD_LAYOUT", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },

  FETCH_FLATS_PLANNINGS_BY_APARTMENT({ commit }, data) {
    return new Promise((resolve, reject) => {
      getFlatsPlannings(data)
        .then((response) => {
          commit("SET_FLATS_PLANNINGS_BY_APARTMENT", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  FETCH_ROOMS_COUNT_BY_APARTMENT({ commit }, data) {
    return new Promise((resolve, reject) => {
      getRoomsCountByApartment(data)
        .then((response) => {
          commit("SET_ROOMS_COUNT_BY_APARTMENT", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  FETCH_BADGES({ commit }) {
    return new Promise((resolve, reject) => {
      getBadges()
        .then((response) => {
          commit("SET_BADGES", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  BOOK_FLAT(_, data) {
    return new Promise((resolve, reject) => {
      bookFlat(data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UNBRON_FLAT(_, bron_id) {
    return new Promise((resolve, reject) => {
      unbronFlat(bron_id)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
